import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader';
import { DataService } from 'src/app/_services/data.service';
import { CorporateVendorService } from 'src/app/_services/corporate-vendor.service';


@Component({
  selector: 'app-corporate-vendor-add-vehicle',
  templateUrl: './corporate-vendor-add-vehicle.component.html',
  styleUrls: ['./corporate-vendor-add-vehicle.component.css']
})
export class CorporateVendorAddVehicleComponent implements OnInit {
  public spinkit = Spinkit;
  _editVehicleProfileForm :FormGroup;
  _submitted = false;
  _VehicleTypes=[];
  _status:number;
  _msg:string;
  constructor(
    private _formBuilder: FormBuilder,
    private _DataService:DataService,
    private _CorporateVendorService:CorporateVendorService,
    private _Router:Router,
  ) { }

  ngOnInit() {
    this._editVehicleProfileForm = this._formBuilder.group({
      vehicle_type_id: ['', Validators.required],
      vehicle_make: ['', Validators.required],
      vehicle_model: ['', Validators.required],
      vehicle_seating_capacity: ['', Validators.required],
      ownership_type: ['own', Validators.required],
      service_type: ['regular', Validators.required],
      traffic_plate_number: ['', Validators.required],
      dafter_details: ['', Validators.required],
      vender_id: ['2', Validators.required],
    });
    
    this._DataService.getVehicleType().subscribe(res=>{
      this._VehicleTypes=res['data'];
    },error => {        
      console.log(error);     
    });
  }
  get f() { return this._editVehicleProfileForm.controls; }
  onSubmit(){
   this._submitted = true;      
    if(this._editVehicleProfileForm.invalid){
      return false;
    } 
    this._CorporateVendorService.addVehicle(this._editVehicleProfileForm.value).subscribe(res=>{     
      this._status=res['status'];  
      this._msg=res['message'];      
      if(this._status==1){
        this._Router.navigate(['/corp-vendor']);  
      } 
    },error => {        
      console.log(error);  
      this._status=0;
      this._msg='Unable to add Driver. Because of Internal Server Error,Try again Later';
    }); 
  }
 
}
